import React from 'react';
import { FormInputFeedback } from '~form';
import { helpersUtils } from '~helpers';
import FormErrorContainer from './FormErrorContainer';
import authPropTypes from '../prop-types/authPropTypes';

var FormSignError = function FormSignError(_ref) {
  var errorMessage = _ref.errorMessage;

  if (!errorMessage) {
    return null;
  }

  return /*#__PURE__*/React.createElement(FormErrorContainer, null, /*#__PURE__*/React.createElement(FormInputFeedback, {
    feedbackType: "error",
    id: errorMessage.errorType || helpersUtils.generateUniqueId()
  }, errorMessage.errorDescription));
};

FormSignError.defaultProps = {
  errorMessage: undefined
};
export default FormSignError;